<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/sbg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">企业仓库</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            提供收货、入库、领料等环节的管控及库存的查询、数据导出工作<br/>
            规范	仓库管理，实现仓库管理全过程精细化。
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/s1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/sicon1.png" alt="">
            </div>
            <div class="tip">
              待入库订单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      记录每笔物料订单采购情况，可以查看采购记录
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/s2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/sicon2.png" alt="">
            </div>
            <div class="tip">
              入库单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      采购的产品到货后，需要进行入库登记。支持
                      分批入库，即同批次采购的产品，由于到货日
                      期可能不同，可以分开进行入库处理
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/s3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/sicon3.png" alt="">
            </div>
            <div class="tip">
              领料单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      实时查看制品库存，出入库记录明细；实时
                      展示库存波动和库存水位，提升库存利用率
                      和周转效率；规范生产领料流程，保持井井
                      有序，避免流程不合理
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/s4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/sicon4.png" alt="">
            </div>
            <div class="tip">
              库存
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      可及时了解每类元件库存停留时间、呆滞
                      情况，加速库存周转率；减少库存占用资金
                      情况，减少费用支出，降低运营资金需求，
                      建立一个扎实的、规范化的、准确反映企
                      业经营状况的管理体系
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'CompanyStock',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
